import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Import action types
import {
  GET_SUCCESS,
  GET_ERRORS,
  SET_AVATAR,
  SET_SERVICE_REGISTERED,
  SET_USER,
  SET_ERROR,
  UPDATE_BALANCE,
} from "../actions/types";

// Import isEmpty utility function
const isEmpty = require("is-empty");

// Initial state of the reducer
const initialState = {
  isAuthenticated: false,
  user: {},
};

// Reducer function
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    // Handle GET_SUCCESS action
    case GET_SUCCESS:
      return {
        ...state, // spread operator to copy existing state
        flag: false,
        serviceData: action.payload,
      };
    // Handle GET_ERRORS action
    case GET_ERRORS:
      return {
        ...state, // spread operator to copy existing state
        flag: false,
      };
    // Handle SET_AVATAR and SET_USER action
    case SET_AVATAR:
      return {
        ...state,
        user: {
          ...state.user,
          avatar: action.payload.avatar,
        },
      };
    // Mark the current user as having registered a service (onboarding done)
    // so route guards let them into the app without a re-login.
    case SET_SERVICE_REGISTERED:
      return {
        ...state,
        user: {
          ...state.user,
          isServiceRegisted: true,
        },
      };
    case SET_USER: {
      const incoming = action.payload.decoded_data || {};
      // isServiceRegisted only ever transitions false -> true (a user can't
      // drop below one service), so a background refetch reporting it false for
      // the same user is a stale read from before onboarding committed. Don't
      // let it downgrade the flag — otherwise the route guard bounces a
      // just-onboarded user back to the (blank) Register Location step.
      const sameOrUnknownUser =
        !incoming.userId ||
        !state.user ||
        !state.user.userId ||
        incoming.userId === state.user.userId;
      const keepRegistered =
        !isEmpty(incoming) &&
        sameOrUnknownUser &&
        state.user &&
        state.user.isServiceRegisted === true &&
        incoming.isServiceRegisted !== true;
      return {
        ...state,
        // isAuthenticated: !isEmpty(action.payload.decoded_data), // check if decoded data is empty
        isAuthenticated:
          localStorage.jwtToken && !isEmpty(incoming), // check if decoded data is empty
        user: keepRegistered
          ? { ...incoming, isServiceRegisted: true }
          : incoming,
      };
    }
    // Handle SET_ERROR action
    case SET_ERROR:
      return {
        ...state,
        isAuthenticated: false,
        user: action.payload,
        msg: "Incorrect email or password", // set error message
      };
      case UPDATE_BALANCE:
      return {
        ...state,
        user: {
          ...state.user,
          balance: action.payload, // Update balance
        },
      };
    // Default case
    default:
      return state;
  }
};

const persistConfig = {
  keyPrefix: "tradetribe-",
  key: "auth",
  storage,
};

export default persistReducer(persistConfig, authReducer);
